import React from 'react'
import StatsTable from './StatsTable'
import OnboardingTip from './OnboardingTip'
import Resource from '../Resource'

export default class LeaderboardContainer extends React.Component {
  render() {
    return (
      <div className="screen leaderboard screen-flex-wrapper">
        <div className="navigation-bar">
          <div className="title">Leaderboard</div>
        </div>
        <OnboardingTip text="Track your progress and see how you compare to others in the EL-FIT program!" />
        <div className="screen-scroll-content">
          <h3>
            Average Step Count
            <div className="meta right">last two weeks</div>
          </h3>
          <Resource collection path={['leaderboard']} placeholder={[]}>
            {(leaderboard) => <StatsTable stats={leaderboard} />}
          </Resource>
        </div>
      </div>
    )
  }
}
